import Svg, { Path, type SvgProps } from 'react-native-svg'

export function AutoPayIcon(props: SvgProps) {
  return (
    <Svg width={24} height={24} fill="none" {...props}>
      <Path
        stroke="#2F3133"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M3 2v6h6"
      />
      <Path
        stroke="#2F3133"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M21 12A9 9 0 0 0 6 5.3L3 8M21 22v-6h-6"
      />
      <Path
        stroke="#2F3133"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M3 12a9 9 0 0 0 15 6.7l3-2.7"
      />
      <Path
        stroke="#2F3133"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      />
    </Svg>
  )
}
